import React, { Fragment, useState, useEffect } from "react";
import Navbar from "../../Components/Navbar";
import SideBar from "./../../Components/Sidebar";
import { GET, POST, PUT } from "./../dataSaver";
import { ErrorToaster, SuccessToaster } from "./../../utils/toaster";
import style from "./index.module.scss";
import LevelTwoHeader from "../../Components/LevelTwoHeader";
import CommonSwitch from "../../Components/CommonFields/CommonSwitch";
import { InputGroup } from "@blueprintjs/core";

const UserConfigurationForCustomers = () => {
  const [isExpanded, setIsExpanded] = useState(true);
  const [userGeneralConfig, setUserGeneralConfig] = useState(null);
  const [onlySiteRoleConfigViaGroup, setOnlySiteRoleConfigViaGroup] = useState(false);
  const [description, setDescription] = useState("");

  const getIsExpanded = (value) => {
    setIsExpanded(value);
  };

  useEffect(() => {
    loadUserGeneralConfig();
  }, []);

  const loadUserGeneralConfig = async () => {
    try {
      const { data } = await GET("user-management-service/user/generalConfig");
      if (data) {
        setUserGeneralConfig(data);
        setOnlySiteRoleConfigViaGroup(data?.onlySiteRoleConfigViaGroup || false);
        setDescription(data?.description || "");
        sessionStorage.setItem("onlySiteRoleConfigViaGroup", data?.onlySiteRoleConfigViaGroup);
      }
    } catch (e) {
      console.error("Error loading user general config:", e);
    }
  };

  const handleSave = async () => {
    let data = {
      onlySiteRoleConfigViaGroup: onlySiteRoleConfigViaGroup,
      description: description || "",
    };

    if (userGeneralConfig) {
      await PUT("user-management-service/user/generalConfig", JSON.stringify(data))
        .then(async () => {
          SuccessToaster("Config Updated Successfully");
          await loadUserGeneralConfig();
        })
        .catch((error) => {
          ErrorToaster(error);
        });
    } else {
      await POST("user-management-service/user/generalConfig", JSON.stringify(data))
        .then(async () => {
          SuccessToaster("Config Added Successfully");
          await loadUserGeneralConfig();
        })
        .catch((error) => {
          ErrorToaster(error);
        });
    }
  };

  return (
    <Fragment>
      <div>
        <Navbar />
        <div className={style.margin20}>
          <div
            className={`${isExpanded ? style.bigCardGrid : style.smallCardGrid
              }`}
          >
            <div>
              <SideBar isExpanded={isExpanded} getIsExpanded={getIsExpanded}>
                <div></div>
              </SideBar>
            </div>
            <div>
              <LevelTwoHeader
                heading={"USER CONFIGURATION"}
                path={"/Screens/ReferenceList/customerAdminDashboard"}
                callingFrom={"Customer Admin"}
                needHeader={true}
              />

              <div className={style.marginTop35}>
                <div className={style.centreCardStyle}>
                  <div className={style.margin20}>
                    <div className={style.customersAdminColumngrid3}>
                      <div></div>
                      <div>
                        <div className={`${style.customersAdminCardStyle3Scrollable} `}>
                          <div
                            className={`${style.editHealthCareGrid2} ${style.marginLeft20} ${style.marginTop10}`}
                          >
                            <div className={style.entityLableStyle3}>
                              Adding Site By Role*
                            </div>
                            <div className={style.displayInRow}>
                              <CommonSwitch
                                label={
                                  onlySiteRoleConfigViaGroup === true ? "YES" : "NO"
                                }
                                className={`${style.textAlignLeft} ${style.switchFontStyle} ${style.flexLeft}`}
                                onChange={() =>
                                  setOnlySiteRoleConfigViaGroup(!onlySiteRoleConfigViaGroup)
                                }
                                checked={onlySiteRoleConfigViaGroup}
                              />
                            </div>
                          </div>

                          <div
                            className={`${style.editHealthCareGrid2} ${style.marginLeft20} ${style.marginTop10}`}
                          >
                            <div className={style.entityLableStyle3}>
                              Description
                            </div>
                            <div className={style.displayInRow}>
                              <InputGroup
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                placeholder="Enter description"
                                className={style.halfWidth}
                              />
                            </div>
                          </div>

                          <div
                            className={`${style.floatRight} ${style.marginTop10}`}
                          >
                            <button
                              className={`${style.buttonStyle} ${style.marginLeft20}`}
                              onClick={() => handleSave()}
                            >
                              SAVE
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={style.spaceBetween}>
              <p className={style.poweredBy}>Powered by - TimeSmartAI.Inc LLP</p>
              <p className={style.poweredBy}>© TimeSmartAI.Inc</p>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default UserConfigurationForCustomers;
